
import { defineComponent, computed, watch, PropType } from "vue";
import { GamificationEvent } from "@/models";
import { getTranslatedString as $t } from "@/i18n";

export default defineComponent({
	name: "GamificationRewardToast",
	props: {
		events: {
			type: Array as PropType<GamificationEvent[]>,
			default: () => [],
		},
		visible: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["dismissed"],
	setup(props, { emit }) {
		const displayedEvents = computed(() =>
			props.events.filter(
				e =>
					e.type === "REPUTATION_GAINED" ||
					e.type === "BADGE_EARNED" ||
					e.type === "LEVEL_REACHED",
			),
		);

		watch(
			() => props.visible,
			val => {
				if (val) {
					setTimeout(() => emit("dismissed"), 4000);
				}
			},
		);

		const eventIcon = (event: GamificationEvent) => {
			if (event.type === "BADGE_EARNED") return event.badge_icon || "military_tech";
			if (event.type === "LEVEL_REACHED") return "emoji_events";
			return "auto_awesome";
		};

		const eventBgColor = (event: GamificationEvent) => {
			if (event.type === "BADGE_EARNED") return "bg-purple-100";
			if (event.type === "LEVEL_REACHED") return "bg-yellow-100";
			return "bg-blue-100";
		};

		const eventIconColor = (event: GamificationEvent) => {
			if (event.type === "BADGE_EARNED") return "text-purple-600";
			if (event.type === "LEVEL_REACHED") return "text-yellow-600";
			return "text-blue-600";
		};

		const eventTitle = (event: GamificationEvent) => {
			if (event.type === "REPUTATION_GAINED")
				return $t("gamification.reward_points", { amount: event.amount });
			if (event.type === "BADGE_EARNED")
				return event.badge_name || $t("gamification.reward_badge_earned");
			if (event.type === "LEVEL_REACHED")
				return $t("gamification.reward_level_reached", { level: event.level_value });
			return "";
		};

		const eventSubtitle = (event: GamificationEvent) => {
			if (event.type === "REPUTATION_GAINED") return $t("gamification.reward_keep_it_up");
			if (event.type === "BADGE_EARNED")
				return event.badge_description || $t("gamification.reward_new_badge");
			if (event.type === "LEVEL_REACHED")
				return event.goal_name || $t("gamification.reward_goal_progressed");
			return "";
		};

		return {
			displayedEvents,
			eventIcon,
			eventBgColor,
			eventIconColor,
			eventTitle,
			eventSubtitle,
		};
	},
});
